import type { FunctionComponent } from "react";
import { generatePath, NavLink } from "react-router-dom";

import Card from "~/components/Card";
import DetailsListDivider from "~/components/DetailsList/components/DetailsListDivider";
import DetailsListItem from "~/components/DetailsList/components/DetailsListItem";
import Headline from "~/components/Headline";
import { CLIENT_DETAILS_PATH, PROJECT_DETAILS_PATH_WITH_TAB_ID, QUOTA_DETAILS_PATH } from "~/constants/appRoutes.ts";
import InvoiceDetailsLink from "~/modules/billing/components/InvoiceDetailsView/components/InvoiceDetailsLink.tsx";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import { getFullPhaseTitle } from "~/modules/project/utils/projectPhaseUtils.ts";

type Props = {
	quota: QuotaWithRelations
};

const AdvanceInvoiceDetailsSection: FunctionComponent<Props> = ({ quota }) => {
	const clientData = quota.client;
	return <Card title="Abrechnungskontingent"
				 padding="none"
	>
		<div className="grid grid-cols-[auto_1fr] gap-4 p-4">
			<DetailsListItem label="Titel">
				<InvoiceDetailsLink
					to={generatePath(QUOTA_DETAILS_PATH, { clientId: clientData.id, quotaId: quota.id })}
				>
					{quota.title}
				</InvoiceDetailsLink>
			</DetailsListItem>
			<DetailsListDivider />
			<DetailsListItem label="Kunde">
				<InvoiceDetailsLink
					to={generatePath(CLIENT_DETAILS_PATH, { clientId: clientData.id })}
				>
					{clientData.displayName}
				</InvoiceDetailsLink>
			</DetailsListItem>
			<DetailsListDivider />
			<DetailsListItem label="Phasen">
				<div className="space-y-2">
					{quota.projectPhases.map((phase) => {
						return <div key={phase.id}
									className="flex items-center gap-x-2"><NavLink
							to={generatePath(PROJECT_DETAILS_PATH_WITH_TAB_ID, {
								projectId: phase.projectId,
								tabId: `phase-${phase.phaseNumber}`,
							})}
							className="group flex grow items-center justify-between rounded-lg border border-gray-200 px-4 py-2 hover:bg-gray-100">
							<div>
								<Headline type="h5"
										  color="muted">{getFullPhaseTitle(phase)}</Headline>
								<div className="text-sm text-gray-500">{phase.project.titleWithNumber}</div>
							</div>

						</NavLink>
						</div>;
					})}
				</div>
			</DetailsListItem>
		</div>
	</Card>;
};

export default AdvanceInvoiceDetailsSection;